<titulo-modal>{{label}}</titulo-modal>
<ng-content select=[button]></ng-content>
<p class="mt-1">
  <small style="font-size: 90%; color: #7f7f7f;"><ng-content select=[observation]></ng-content>
  </small>
</p>
